import { Injectable } from '@angular/core';
import { Headers } from '@angular/http';

import * as JSZip from 'jszip';
import * as FileSaver from 'file-saver';

import { IFile } from './file.model';
import { Api } from 'app/core/api.service';
import { ResponseContentType, Http } from '@angular/http';

export function isIE() {
    return navigator.userAgent.indexOf('Trident') >= 0;
}

export function isEdge() {
    return navigator.userAgent.indexOf('Edge') >= 0;
}

/** Скачивает файл с помощью <form> */
function downloadByUrl(url: string): void {
    const form: HTMLFormElement = document.createElement('form');
    form.setAttribute('action', url);
    form.setAttribute('method', 'GET');
    if (isIE() || isEdge()) {
        form.setAttribute('target', '_blank');
    }
    form.style.display = 'none';
    document.body.appendChild(form);
    form.submit();
    setTimeout(() => document.body.removeChild(form), 1000);
}

/** Сервис скачивания файлов */
@Injectable()
export class DownloadService {

    constructor(private _http: Http, private _api: Api) {
    }

    /** Скачивает файл */
    async file(file: IFile) {
        const blob = await this.getBlob(file);
        FileSaver.saveAs(blob, file.name);
    }

    // /** Скачивает zip-архив с файлами */
    async archive(files: IFile[], archiveName: string) {
        const jszip = new JSZip();
        const promises = files.map(async file => {
            const blob = await this.getBlob(file);
            jszip.file(file.name, blob);
        })
        await Promise.all(promises);
        const content = await jszip.generateAsync({ type: 'blob' });
        FileSaver.saveAs(content, archiveName);
    }

    async download(url: string) {
        const options = {
            headers: new Headers({
                Authorization: this._api.getAuthorizationHeader()
            }),
            responseType: ResponseContentType.Blob
        };
        const response = await this._http.get(url, options).toPromise();
        return response.blob();
    }

    private async getBlob(file: IFile) {
        const url = `/api/v2/file/${file.id}/${file.token}`;
        return this.download(url);
    }
}